import { createFileRoute } from "@tanstack/react-router";
import AdminSecurityPosture from "@/pages/AdminSecurityPosture";

export const Route = createFileRoute("/admin/security/posture/")({
  component: AdminSecurityPosture,
});
